import Sortable from 'sortablejs';

export default {
  Draggable: {
    mounted() {
      this.listGroup = this.el.dataset.draggableListGroup;

      this.initialize();
    },

    updated() {
      const listGroup = this.el.dataset.draggableListGroup;

      if (listGroup !== this.listGroup) {
        this.destroy();
        this.listGroup = listGroup;
        this.initialize();
      }
    },

    initialize() {
      this.wasDragging = false;

      this.clickGuard = e => {
        if (this.wasDragging) {
          e.stopImmediatePropagation();
          e.preventDefault();
          this.wasDragging = false;
        }
      };
      this.el.addEventListener('click', this.clickGuard, true);

      const options = {
        animation: 150,
        fallbackOnBody: true,
        swapThreshold: 0.65,
        delay: 100,
        dragClass: 'drag-item',
        ghostClass: 'drag-ghost',
        forceFallback: true,
        dataIdAttr: 'data-sortable-id',
        filter: '.no-drag',
        preventOnFilter: false, // allow phx-click to fire on filtered (no-drag) elements
        onStart: e => this.handleDragStart(e),
        onEnd: e => this.handleDragEnd(e),
      };

      if (this.listGroup) options.group = this.listGroup;

      const handle = this.el.dataset.draggableHandle;
      if (handle) options.handle = `.${handle}`;

      const item = this.el.dataset.draggableItem;
      if (item) options.draggable = item;

      this.sortable = new Sortable(this.el, options);
    },

    destroyed() {
      this.destroy();
    },

    destroy() {
      if (this.clickGuard) {
        this.el.removeEventListener('click', this.clickGuard, true);
      }
      this.sortable.destroy();

      this.listGroup = undefined;
      this.sortable = undefined;
    },

    handleDragStart(e) {
      this.wasDragging = true;
      this.el.classList.add('drag-in-progress');
    },

    handleDragEnd(e) {
      this.el.classList.remove('drag-in-progress');
      // Clear the drag flag on the next tick so a synthetic click fired
      // immediately after drop is still suppressed by clickGuard, but the
      // user's next real click (e.g. select_step) is not swallowed.
      setTimeout(() => {
        this.wasDragging = false;
      }, 0);

      const endEvent = this.el.dataset.draggableEndEvent;
      const eventTarget = this.el.dataset.draggableEventTarget;

      const payload = {
        from_index: e.oldIndex,
        to_index: e.newIndex,
        from_list_name: e.from.dataset.name,
        to_list_name: e.to.dataset.name,
      };

      // Optionally add slug if the dragged item has one
      const slug = e.item.dataset.slug || e.item.dataset.stepSlug;
      if (slug) {
        payload.slug = slug;
      }

      if (eventTarget) {
        this.pushEventTo(eventTarget, endEvent, payload);
      } else {
        this.pushEvent(endEvent, payload);
      }
    },
  },
};
